import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
} from '@fortawesome/free-brands-svg-icons';

import Drm from 'Components/Utility/Drm';
import KeyReveals from 'Helpers/Order/KeyReveals';
import ProductCover from 'Components/Utility/ProductCover';
import ProductRequirements from 'Helpers/Product/ProductRequirements';

import 'Components/Order/KeyReveals/MysteryRevealCard.scss';

function MysteryRevealCard({ game, cardNumber, count, totalCards, loaded }) {
  const mysteryGameDetails = get(game, 'mysteryGameDetails', {});
  const gamePlatforms = get(game, 'platforms', {});
  const gameDrm = get(game, 'drm', {});
  const gameCover = get(game, 'cover', '');
  const gameName = get(game, 'name', '');

  let validPlatforms = Object.keys(gamePlatforms).filter(p => gamePlatforms[p]);
  let drmPlatform = '';
  let cover = gameCover;

  if (!isEmpty(mysteryGameDetails)) {
    validPlatforms = ProductRequirements.validPlatforms(mysteryGameDetails);
  }
  if (gameDrm) {
    drmPlatform = Object.keys(gameDrm).filter(p => gameDrm[p])[0];
  }

  if (mysteryGameDetails.cover) {
    cover = mysteryGameDetails.cover;
  }

  return (
    <article className={classNames('MysteryRevealCard', { 'MysteryRevealCard--flipped': (loaded && cardNumber === 0) || cardNumber < count || count >= totalCards })}>
      <div className="MysteryRevealCard__content">
        <div className="MysteryRevealCard__front">
          <ProductCover
            cover={cover}
            alt={`Product cover for ${gameName}`}
          />
          <div className="MysteryRevealCard__body">
            <div className="">
              <div className="MysteryRevealCard__title">
                {KeyReveals.formatProductName(gameName)}
              </div>
            </div>
            <div className="MysteryRevealCard__icons">
              {drmPlatform && drmPlatform !== 'drm_free' &&
                <div className="MysteryRevealCard__drm">
                  <Drm drmType={drmPlatform} colorOverride="dark" iconSize="small" />
                </div>
              }
              {!isEmpty(validPlatforms) &&
                <div className="MysteryRevealCard__os">
                  {includes(validPlatforms, 'windows') &&
                    <FontAwesomeIcon icon={fabFaWindows} />
                  }
                  {includes(validPlatforms, 'mac') &&
                    <FontAwesomeIcon icon={fabFaApple} />
                  }
                  {includes(validPlatforms, 'linux') &&
                    <FontAwesomeIcon icon={fabFaLinux} />
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div className="MysteryRevealCard__back">
          ?
        </div>
      </div>
    </article>
  );
}

MysteryRevealCard.propTypes = {
  game: PropTypes.shape({}).isRequired,
  cardNumber: PropTypes.number,
  count: PropTypes.number,
  totalCards: PropTypes.number,
  loaded: PropTypes.bool,
};

MysteryRevealCard.defaultProps = {
  cardNumber: 0,
  count: 1,
  totalCards: 1,
  loaded: false,
};

export default MysteryRevealCard;
